import React from 'react';
import "./experienceBox.css"
import account from "../../res/img/account.png"
import {useHistory} from "react-router-dom";
import {ENV} from "../../services/env";
const ExperienceBox = (props) => {
    const {item} = props
    const history = useHistory()
    return (
        <div className={"experience-box"}>
            <div className={"experience-box-title"}>
                <img alt="experience" src={item.image ? ENV.API.IMG + item.image : account}/>
                <span>
                    {item.title}
                </span>
            </div>
            <div  className={"experience-box-des"} dangerouslySetInnerHTML={{__html:item.description}}/>
            <div className="more_btn">
                <div onClick={() => {history.push(`/${props.route}/${item._id}`,{props})}}>
                    <a>ادامه مطلب</a>
                </div>
            </div>
            <div className={"flag-box"}>
                <div className={"top-flag"} />
                <div className={"mid-flag"} />
                <div className={"down-flag"} />
            </div>
        </div>
    );
};

export default ExperienceBox;
